import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, LoaderButton, ModalWithSidebar } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NewMemberBlock } from 'src/components/settings/NewMemberBlock';
import { useStore } from 'src/stores';
import { ExistingMember } from './ExistingMember';
export const AddNewMemberModal = observer(_ref => {
  let _ref$select = _ref.select,
    select = _ref$select === void 0 ? false : _ref$select,
    _ref$customTrigger = _ref.customTrigger,
    customTrigger = _ref$customTrigger === void 0 ? undefined : _ref$customTrigger,
    memberType = _ref.memberType;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const dontHideFormForUserRoles = [1, 2];
  const tabs = [{
    label: t('add_new_property_flow.new_team_member'),
    name: 'new'
  }];
  if (store.addNewProperty.contactInformation.teammembers.length > 1 || dontHideFormForUserRoles.includes(store.account.userProfile.userRole)) {
    tabs.push({
      label: t('add_new_property_flow.pick_from_existing'),
      name: 'existing'
    });
  }
  const modalTitle = memberType === 'building' ? t('add_new_property_flow.select_primary_building_contact') : t('add_new_property_flow.select_primary_utilities_contact');
  const _useState = useState(tabs[0].name),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  const handleTabChange = (e, newValue) => {
    if (newValue) setSelectedTab(newValue);
  };
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '129-add-new-member-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('add_new_property_flow.add_team_member')));
  const selectTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    'custom-attribute': '130-add-new-member-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus-circle"
  }), t('add_new_property_flow.member_not_in_system'));
  const getRightButton = () => {
    if (selectedTab === 'new') {
      return /*#__PURE__*/React.createElement(LoaderButton, {
        loadingText: "Adding...",
        buttonText: t('add_new_property_flow.add_team_member'),
        successText: "Successfully added",
        errorText: "Addition failed",
        status: "success"
      });
    }
    if (selectedTab === 'existing') {
      return /*#__PURE__*/React.createElement(LoaderButton, {
        loadingText: "Saving...",
        buttonText: "Save selection",
        successText: "Successfully saved",
        errorText: "Saving failed",
        status: "success"
      });
    }
  };
  const trigger = select ? selectTrigger : defaultTrigger;
  return /*#__PURE__*/React.createElement(ModalWithSidebar, {
    trigger: customTrigger || trigger,
    title: modalTitle,
    tabs: tabs,
    selectedTab: selectedTab,
    handleTabChange: handleTabChange,
    rightButton: getRightButton(),
    noInnerFooter: true,
    noPadding: true
  }, selectedTab === 'new' && /*#__PURE__*/React.createElement(NewMemberBlock, {
    memberType: memberType
  }), selectedTab === 'existing' && /*#__PURE__*/React.createElement(ExistingMember, {
    memberType: memberType
  }));
});
AddNewMemberModal.propTypes = {
  customTrigger: PropTypes.node,
  select: PropTypes.bool
};